import { Link } from "react-router-dom";
import useReveal from "../hooks/useReveal";
import { BRAND } from "../lib/data";
import { Award, Heart, Sparkles, Users } from "lucide-react";

export default function About() {
  useReveal();
  return (
    <div data-testid="about-page" className="pt-28 pb-24 bg-[#0B0B0B] text-white">
      <section className="px-6 md:px-12 py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 reveal">
            <span className="gold-divider text-[11px] tracking-[0.32em] uppercase">About Enrich</span>
            <h1 className="font-display text-5xl md:text-6xl mt-5">A Sanctuary for <span className="italic text-[#C9A34E]">Beauty</span></h1>
            <p className="text-white/75 mt-7 leading-relaxed">
              Enrich Hair & Beauty is a luxury salon located in Pendle Hill, Sydney, dedicated to delivering professional hair,
              skin, and beauty services in a relaxing environment. We specialize in hair colouring, highlights, keratin, nanoplasty,
              facials, threading, waxing, and makeup.
            </p>
            <p className="text-white/65 mt-5 leading-relaxed">
              Every guest is welcomed into a thoughtful, calming space — where artistry, premium products, and personal care come together.
              Our stylists pour expertise into every detail, so you leave feeling renewed inside and out.
            </p>
            <div className="grid grid-cols-2 gap-6 mt-10">
              <div className="border border-[#C9A34E]/20 rounded-2xl p-5">
                <p className="font-display text-3xl text-[#C9A34E]">10+</p>
                <p className="text-xs tracking-[0.22em] uppercase text-white/65 mt-2">Years Experience</p>
              </div>
              <div className="border border-[#C9A34E]/20 rounded-2xl p-5">
                <p className="font-display text-3xl text-[#C9A34E]">500+</p>
                <p className="text-xs tracking-[0.22em] uppercase text-white/65 mt-2">Happy Clients</p>
              </div>
              <div className="border border-[#C9A34E]/20 rounded-2xl p-5">
                <p className="font-display text-3xl text-[#C9A34E]">40+</p>
                <p className="text-xs tracking-[0.22em] uppercase text-white/65 mt-2">Treatments</p>
              </div>
              <div className="border border-[#C9A34E]/20 rounded-2xl p-5">
                <p className="font-display text-3xl text-[#C9A34E]">5★</p>
                <p className="text-xs tracking-[0.22em] uppercase text-white/65 mt-2">Avg. Rating</p>
              </div>
            </div>
            <Link to="/booking" data-testid="about-book-btn" className="inline-flex items-center gap-2 mt-10 bg-[#C9A34E] text-[#0B0B0B] hover:bg-[#b08d3e] rounded-full px-8 py-3.5 text-sm tracking-[0.2em] uppercase font-medium transition-colors">
              Book A Visit
            </Link>
          </div>

          <div className="lg:col-span-6 reveal">
            <div className="relative">
              <div className="absolute -inset-6 rounded-full bg-[#C9A34E]/10 blur-3xl" />
              <img src={BRAND.logo} alt="Enrich" className="relative w-full max-w-md mx-auto rounded-3xl ring-1 ring-[#C9A34E]/30" />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="px-6 md:px-12 py-16 bg-[#0E0E0E]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center reveal">
            <span className="gold-divider text-[11px] tracking-[0.32em] uppercase">Our Values</span>
            <h2 className="font-display text-4xl md:text-5xl mt-5">What We Stand For</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
            {[
              { Icon: Award, t: "Craftsmanship", d: "Precision cutting, colour & treatments by trained pros." },
              { Icon: Heart, t: "Genuine Care", d: "We listen, advise, and treat every guest like family." },
              { Icon: Sparkles, t: "Premium Quality", d: "Curated, salon-grade products you can trust." },
              { Icon: Users, t: "Community", d: "A welcoming space for all of Pendle Hill & beyond." },
            ].map((v, i) => (
              <div key={v.t} className="reveal bg-[#141414] border border-[#C9A34E]/15 rounded-2xl p-7" style={{ transitionDelay: `${i * 80}ms` }}>
                <v.Icon className="text-[#C9A34E]" size={26} />
                <h3 className="font-display text-xl mt-5">{v.t}</h3>
                <p className="text-sm text-white/65 mt-3 leading-relaxed">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
